import { browserEnv, isSoul, processUrlSetter } from "@/libs/lib";
import bridge from "@clover/bridge";
import { ComponentPublicInstance, createApp } from "vue";
import app from "./index.vue";
import { WxSdk } from "./wx";

let vm: ComponentPublicInstance;

const createShare = (props: Record<string, unknown>) => {
  const dom = document.createElement("div");
  document.body.appendChild(dom);
  vm = createApp(app, props).mount(dom);
};

const openShare = () => ((<Record<string, boolean>>vm.$data).showShare = true);

const shareHandler = (config) => {
  if (!config || !config.enabled?.length) return;

  if (isSoul()) {
    createShare({ config });
    bridge.setNavigationRight({
      imageUrl:
        bridge.getAppMode() === "dark"
          ? "https://fe-cdn.soulapp.cn/activity/share_dark-163964.webp"
          : "https://fe-cdn.soulapp.cn/activity/share_light-163964.webp",
    });
    bridge.onNavigationRightClick(() => openShare());
  } else if (browserEnv.isWeixin) {
    const conf = config.outside;
    processUrlSetter(conf.link, false).then((url) => {
      WxSdk.share({
        title: conf.title,
        desc: conf.desc,
        link: url,
        imgUrl: conf.image,
      });
    });
  }
};

export { shareHandler };
